<template>
	<v-container>
		<v-row class="contentRow">
			<v-col cols="9">
				<h1 class="mb-2 text-left">Transaction Search</h1>
			</v-col>
			<v-col cols="3">
				<v-switch class="pl-12"
					v-model="showSearchOption"
					label="Toggle Search Options"
				>
				</v-switch>
			</v-col>
		</v-row>
		<v-row class="contentRow" v-if="showSearchOption">
			<v-col>
				<v-row>
					<v-col cols="3">
						<v-text-field
								outlined
								label="Counterpart (Client ID)"
								placeholder="Client ID"
								v-model="searchValues.counterpart"
								dense
						>
							<template v-slot:append>
								<v-btn
										height="40px"
										style="margin-top: -8px;margin-right: -12px;min-width:7px;width:7px"
										align="center"
										color="primary"
										@click="dialog=true"
								>
									<v-icon small>fas fa-address-book</v-icon>
								</v-btn>
							</template>
						</v-text-field>
						<v-text-field
								outlined
								label="Sender Order Number"
								placeholder="Sender Order Number"
								v-model="searchValues.senderordernumber"
								dense
						></v-text-field>
					</v-col>
					<v-col cols="3">
						<v-menu
								v-model="menu2"
								:close-on-content-click="false"
								:nudge-right="40"
								transition="scale-transition"
								offset-y
								min-width="290px"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
										v-model="searchValues.startDate"
										label="Start Date"
										placeholder="Start Date"
										readonly
										v-bind="attrs"
										v-on="on"
										outlined
										dense
								>
								</v-text-field>
							</template>
							<v-date-picker
									@input="menu2 = false"
									label="Start Date"
									@change="(v)=>searchValues.startDate=formatDate(v)"
									:value="changeDateFormat(searchValues.startDate)"
									color="primary"

							></v-date-picker>
						</v-menu>
						<v-text-field
								outlined
								label="Recipient Order Number"
								placeholder="Recipient Order Number"
								v-model="searchValues.recipientordernumber"
								dense
						></v-text-field>
					</v-col>
					<v-col cols="3">
						<v-menu
								v-model="menu2"
								:close-on-content-click="false"
								:nudge-right="40"
								transition="scale-transition"
								offset-y
								min-width="290px"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
										v-model="searchValues.endDate"
										label="End Date"
										placeholder="End Date"
										readonly
										v-bind="attrs"
										v-on="on"
										outlined
										dense
								>
								</v-text-field>
							</template>
							<v-date-picker
									@input="menu2 = false"
									label="End Date"
									@change="(v)=>searchValues.endDate=formatDate(v)"
									:value="changeDateFormat(searchValues.endDate)"
									color="primary"

							></v-date-picker>
						</v-menu>
						<v-text-field
								outlined
								label="Traceability ID"
								placeholder="Traceability ID"
								v-model="searchValues.traceabilityid"
								dense
						></v-text-field>
					</v-col>
					<v-col cols="3">
						<v-text-field
								outlined
								label="Article Number"
								placeholder="Article Number"
								v-model="searchValues.articlenumber"
								dense
						></v-text-field>
						<v-select
								v-model="searchValues.status"
								:items="transactionStatus"
								label="Status"
								placeholder="Status"
								item-value="value"
								item-text="label"
								multiple
								outlined
								dense
						></v-select>
					</v-col>
					<v-col>
						<v-btn color="primary" @click="searchTransaction" >
							Search
						</v-btn>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
		<v-row class="contentRow" align="center">
			<v-col>
				<v-card background-color="transparent" elevation="0" outlined>
					<v-card-title class="text-center justify-left py-6">
						<h3 class="darkColor--text">Transactions</h3>
					</v-card-title>
					<v-data-table
							:loading="transactionOptions.loading"
							theme--
							light
							:headers="headers"
							:items="transactionOptions.data"
							:items-per-page="transactionOptions.limit"
							:server-items-length="transactionOptions.total"
							:options.sync="transactionOptions.options"
							class="light table mx-4 assessed-table"
							:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
					>
						<template v-slot:item.id="{ item }">
							<router-link :to="'/trace/transactions/' + item.id">{{item.id}}</router-link>
						</template>
						<template v-slot:item.timestamp="{ item }">
							{{  item.timestamp | moment("DD.MM.YYYY  h:mm:ss") }}
						</template>
						<template v-slot:item.status="{ item }">
							<v-tooltip top>
								<template v-slot:activator="{ on, attrs }">
									<p class="mx-2 my-0" :style="{ color: item.status.color}" v-bind="attrs" v-on="on">
										<v-icon  small :style="{ color: item.status.color}">fas fa-{{ item.status.icon}}</v-icon>
										{{item.status.description_short}}
									</p>
								</template>
								<span>{{item.status.description_long}}</span>
							</v-tooltip>
						</template>
						<template v-slot:item.blockchainStatus="{ item }" >
							<a  v-if="item.block!=='Awaiting validification'" :href="'https://nodes.orixe.tech/blocks/' + item.block" target='_blank'>Block #{{item.block}}</a>
                            <a  v-if="item.block!=='Awaiting validification'" :href="'https://nodes.orixe.tech/blocks/' + item.block" target='_blank'>Block #{{item.block}}</a>
							<p class="my-0 text-left font-italic" v-if="item.block==='Awaiting validification'">{{item.block}}</p>
						</template>
					</v-data-table>

					<br />
				</v-card>
			</v-col>
		</v-row>
		<!--        Address Book Modal-->
		<v-dialog v-model="dialog" max-width="500px">
			<v-card>
				<v-card-title>Address book</v-card-title>
				<v-data-table
						align="center"
						:loading="!connections"
						theme--
						light
						:headers="headersAddressBook"
						:items="connections"
						:items-per-page="20"
						class="light table"
						:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
				>
					<template v-slot:item.select="{ item }">
						<v-btn color="primary" v-on:click="selectRecipient(item.clientID)">
							Select
						</v-btn>
					</template>
				</v-data-table>
				<v-card-actions>
					<v-btn color="error" text v-on:click="dialog = false" outlined>Close</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import TransactionAPI from "../../api/trace/transaction"
import LoadingState from "../../consts/LoadingState"
import ConnectionAPI from "../../api/connections/connection"
export default {
	name: "SearchTransactionView",
	data() {
		return {
			transactionOptions:{
				limit:10,
				offset:0,
				total:0,
				data:[],
				loading:true,
				options: {},
			},
			headers: [
				{
					text: "Transaction ID",
					align: "start",
					sortable: false,
					value: "id",
					class: "secondary--text"
				},
				{
					text: "Timestamp",
					value: "timestamp",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Sender Order Number",
					value: "senderordernumber",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Recipient Order Number",
					value: "recipientordernumber",
					sortable: false,
					class: "secondary--text"
				},				{
					text: "Article Number",
					value: "articlenumber",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Sender",
					value: "sender",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Recipient",
					value: "recipient",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Status",
					value: "status",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Blockchain Status",
					value: "blockchainStatus",
					sortable: false,
					class: "secondary--text"
				}
			],
			headersAddressBook: [
				{ text: "Client ID", value: "clientID", sortable: false },
				{ text: "Name", value: "name", sortable: false },
				{ text: "Select", value: "select", sortable: false }
			],
			showSearchOption:true,
			dialog:false,
			searchValues:{
				counterpart:undefined,
				startDate:undefined,
				endDate:undefined,
				status:undefined,
				senderordernumber:undefined,
				recipientordernumber:undefined,
				traceabilityid:undefined,
				articlenumber:undefined,
			},
			transactionStatus:[
				{value: 0, label: "Pending"},
				{value: 1, label: "Confirmed"},
				{value: 2, label: "Rejected"},
				{value: 3, label: "Invalid"},
				{value: 4, label: "Cancelled"},
				{value: 5, label: "Rescinded"},
				{value: 9, label: "Edited"},
				{value: 15, label: "Inherited Error"},
				{value: 17, label: "Requested Edit"},
			]
		}
	},
	mounted() {
		this.searchTransaction()
		this.loadConnections()
	},
	watch: {
		"transactionOptions.options": {
			handler () {
				//if user select all
				if (this.transactionOptions.options.itemsPerPage===-1){
					this.transactionOptions.options.itemsPerPage=this.transactionOptions.total
				}
				this.transactionOptions.offset=(this.transactionOptions.options?.page-1) * this.transactionOptions.options?.itemsPerPage
				this.transactionOptions.limit=this.transactionOptions.options?.itemsPerPage
				this.searchTransaction()
			},
			deep: true,
		},
	},
	methods: {
		searchTransaction(){
			let params= {...this.searchValues}
			params.startDate=this.convertToTimestamp(params.startDate)
			params.endDate=this.convertToTimestamp(params.endDate)
			params.status=params.status?.toString()
			let searchParams=params

			this.transactionOptions.loading=true
			TransactionAPI.searchTransaction(this.transactionOptions.limit,this.transactionOptions.offset, 0,searchParams)
				.then(data => {
					this.transactionOptions.total=data?.metadata?.pagination?.totalRecords
					this.transactionOptions.data=data?.data
					this.transactionOptions.loading=false
				})
				.catch(error => {
					this.recentOptions.loading=false
					this.transactionOptions.loading=false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		loadConnections() {
			ConnectionAPI.getConnections()
				.then(data => {
					this.connections=data
				})
				.catch(error => {
					this.recentOptions.loading=false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		selectRecipient(clientID){
			this.searchValues.counterpart=clientID
			this.dialog=false
		},
		formatDate (date) {
			if (!date) return null
			const [year, month, day] = date.split("-")
			return `${day}/${month}/${year}`
		},
		changeDateFormat(date){
			if (!date) return  null
			return  date?.split("/")?.reverse()?.join("-")
		},
		convertToTimestamp(date){
			if (!date) return  undefined
			let formattedDate = date.split("/").reverse()?.join("-")
			return  new Date(formattedDate).getTime()
		}

	}
}
</script>
<style scoped>
.switch-center {
  display: flex;
  justify-content: right;
}
</style>
